import { h } from "preact";
import "./CouponSelectionItem.scss";
import PropTypes from "prop-types";

export default function CouponSelectionItem({ coupon }) {
  return (
    <div class="coupon-selection-item">
      <a href={`/business/${coupon.CompanyID}`} rel="noopener noreferrer">
        <div class="coupon-selection-item__image">
          {coupon.Logo && coupon.Logo !== "" ?
          <img src={"https://www.companyrank.com/logos/" + coupon.Logo}/>
          : <p>{coupon.Name}</p>
          }
          </div>
      </a>
    </div>
  );
}
CouponSelectionItem.propTypes = {
  coupon: PropTypes.object.isRequired,
};
